<template>
  <Toast />
  <ConfirmDialog />
  <router-view />
</template>

<style scoped></style>
